import { getFunctions, httpsCallable } from 'firebase/functions';
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  updatePassword
} from 'firebase/auth';
import app, { auth } from '../firebase/config';

const managePlatformAdmin = httpsCallable(getFunctions(app, 'europe-west1'), 'managePlatformAdmin');

export const adminAccountErrorKey = (error) => {
  const message = String(error?.message || error?.code || '');
  if (message.includes('weak-password') || message.includes('auth/weak-password')) return 'passwordTooShort';
  if (message.includes('invalid-email') || message.includes('auth/invalid-email')) return 'adminEmailRequired';
  if (message.includes('cannot-remove-self')) return 'cannotRemoveSelf';
  if (message.includes('last-admin')) return 'lastAdmin';
  if (message.includes('wrong-password') || message.includes('invalid-credential') || message.includes('auth/wrong-password') || message.includes('auth/invalid-credential')) {
    return 'wrongCurrentPassword';
  }
  if (message.includes('not-admin') || message.includes('sign-in-required') || message.includes('unauthenticated')) {
    return 'accessDenied';
  }
  return 'errorOccurred';
};

export const callManageAdmin = async (payload) => {
  const result = await managePlatformAdmin(payload);
  return result.data || {};
};

export const sendAdminInvite = (email) => sendPasswordResetEmail(auth, email, {
  url: 'https://ezk-wettbewerb.firebaseapp.com/admin/login'
});

export const changeOwnPassword = async (currentPassword, nextPassword) => {
  const user = auth.currentUser;
  if (!user?.email) {
    throw new Error('sign-in-required');
  }
  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  await reauthenticateWithCredential(user, credential);
  await updatePassword(user, nextPassword);
};
